export default function Node_ES6() {
  return <div>Node_ES6 Component</div>;
}
